// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CoffeeOutlinedSvg from "@fishx/icons-svg/es/asn/CoffeeOutlined";
import FishxIcon from '../components/FishxIcon';

var CoffeeOutlined = function CoffeeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CoffeeOutlinedSvg
  }));
};

CoffeeOutlined.displayName = 'CoffeeOutlined';
export default React.forwardRef(CoffeeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CoffeeOutlined.js
// module id = 2281
// module chunks = 0